module.exports = __webpack_public_path__ + "static/media/pos-icon.602b1ea0.png";